import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) {
    if (authService.isBackOffice()) {
      router.navigate(['/backoffice/bookings']);
      return false;
    }
    return true;
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (authService.isOnlyAdmin()) {
    return true;
  }

  if (authService.isSuperAdmin()) {
    router.navigate(['/super-admin']);
    return false;
  }

  router.navigate(['/dashboard']);
  return false;
};

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (authService.isSuperAdmin()) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};

export const adminOrSuperAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (authService.isOnlyAdmin() || authService.isSuperAdmin()) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};

export const nonSuperAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isWebsiteViewMode = route.queryParamMap.get('site_view') === '1';
  if (isWebsiteViewMode) {
    return true;
  }

  if (authService.isAuthenticated && authService.isSuperAdmin()) {
    router.navigate(['/super-admin']);
    return false;
  }

  return true;
};

export const nonPrivilegedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isWebsiteViewMode = route.queryParamMap.get('site_view') === '1';
  if (isWebsiteViewMode) {
    sessionStorage.setItem('site_view_mode', '1');
    return true;
  }

  const persistedWebsiteViewMode = sessionStorage.getItem('site_view_mode') === '1';
  if (persistedWebsiteViewMode) {
    if (!isWebsiteViewMode) {
      const websiteViewUrlTree = router.parseUrl(state.url);
      websiteViewUrlTree.queryParams = {
        ...websiteViewUrlTree.queryParams,
        site_view: '1'
      };
      return websiteViewUrlTree;
    }
    return true;
  }

  const isFromAdminManagement = route.queryParamMap.get('from') === 'admin-management';
  if (isFromAdminManagement) {
    return true;
  }

  if (authService.isAuthenticated && authService.isOnlyAdmin()) {
    router.navigate(['/admin']);
    return false;
  }

  if (authService.isAuthenticated && authService.isSuperAdmin()) {
    router.navigate(['/super-admin']);
    return false;
  }

  if (authService.isAuthenticated && authService.isBackOffice()) {
    router.navigate(['/backoffice/bookings']);
    return false;
  }

  return true;
};

